import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class Home {
  constructor() {
    document
      .querySelector('#homeScr #startBtn')
      .addEventListener('click', this.quickPlay.bind(this));
    document
      .querySelector('#homeScr #missionChoice')
      .addEventListener('click', this.pickMission.bind(this));
  }
  init() {

    this.quickPlayFlag = true;
    this.screenActive = false;

    this.quickplayBtnFlag = false;
    this.missionPickBtnFlag = false;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }

  showScreen(data) {
    if (data['screenKey'] !== 'Home') return false;

    this.screenActive = true;
    document.querySelector('#homeScr').classList.add('active');
    document.querySelector('#homeScr').classList.add('active2');

    document.querySelector('#game_header').classList.add('active');
    setTimeout(() => {
      document.querySelector('#game_header').classList.add('active2');
    }, 0);

    this.titleIndex = -10;
    this.titleInt = setInterval(() => {
      if (this.titleIndex < 18) {
        document
          .querySelector('#homeScr .title')
          .classList.remove(`title${this.titleIndex}`);
      }

      this.titleIndex++;
      if (this.titleIndex > 18) {
        document.querySelector('#homeScr .logo').classList.add(`active`);
        document.querySelector('#homeScr .desc').classList.add(`active`);
        document.querySelector('#homeScr #startBtn').classList.add(`active`);
        document.querySelector('#homeScr #missionChoice').classList.add(`active`);
        this.quickplayBtnFlag = true;
        this.missionPickBtnFlag = true;

        clearInterval(this.titleInt);
      } else {
        document
          .querySelector('#homeScr .title')
          .classList.add(`title${this.titleIndex}`);
      }
    }, 30);
  }
  animateScreen() {
    // gsap.delayedCall(0.1, () => {
    //   document.querySelector('#age_screen .bg').classList.add('active');
    //   document
    //     .querySelector('#age_screen .contents .logo')
    //     .classList.add('active');
    // });
  }

  hideScreen() {
    if (!this.screenActive) return;
    this.screenActive = false;
    document.querySelector('#homeScr').classList.remove('active2');
    // document.querySelector('#homeScr').classList.remove('active2');
  }
  enableCamera() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'gyro_permission_update',
        data: {},
      },
    });

    if (this.quickPlayFlag) {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'Assignment',
          },
        },
      });
    }
    if (!this.quickPlayFlag) {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'MissionPick',
          },
        },
      });
    }


    if (Global.soundEnabled) {
      document.querySelector('#BGAudio').play();
    }
  }

  quickPlay() {
    if (!this.quickplayBtnFlag) return;
    this.quickplayBtnFlag = false;
    this.missionPickBtnFlag = false;

    console.log('quick play');

    this.quickPlayFlag = true;
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: '360quickPlayClick',
      uniqID: Global.U_ID,
    });
    document.querySelector('#homeScr #startBtn').classList.add('clickActive');

    this.onStart();
  }
  pickMission() {
    if (!this.missionPickBtnFlag) return;
    this.missionPickBtnFlag = false;
    this.quickplayBtnFlag = false;

    console.log('pick mission');

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: '360PickMissionClick',
      uniqID: Global.U_ID,
    });
    this.quickPlayFlag = false;
    document.querySelector('#homeScr #missionChoice').classList.add('clickActive');
    this.onStart();


  }
  onStart() {
    setTimeout(() => {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        // iOS 13+ devices
        DeviceOrientationEvent.requestPermission()
          .then((permissionState) => {
            if (permissionState === 'granted') {
              // Permission granted
              Global.deviceOrientationAvailable = true;
              this.enableCamera();
            } else {
              this.hideScreen();
              this.enableCamera();
              // document.querySelector("#gyroButton img").src = "./ui/Gyro-OFF.png";
              document.querySelector("#gyroButton").style.display = "none";
            }
          })
          .catch(console.error);
      } else {
        Global.deviceOrientationAvailable = true;
        this.enableCamera();
      }
    }, 100);

  }


}
